import { render, staticRenderFns } from "./wechatPay.vue?vue&type=template&id=9180d598&"
import script from "./wechatPay.vue?vue&type=script&lang=ts&"
export * from "./wechatPay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports